<template>
<b-container
  class="bg-white d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container
	class="px-lg-5 py-5 py-xl-0 bg-white"
	fluid
	>
	<b-row>
	  <b-col
	    cols="12"
	    md="10"
	    offset-md="1"
	    lg="8"
	    offset-lg="2"
	    xl="4"
	    offset-xl="4"
	    >
	    <div class="p-3 p-sm-5">
	      <h2 class="text-center">
		<slot name="header-top">"It would help if you were not forced to think like a computer just to manage your files."</slot>
	      </h2>
	    </div>
	    <div class="mx-auto p-3">
	      <div class="text-left">	    
		<div class="d-flex">
		  <font-awesome-icon
		    :icon="faCheck"
		    class="mr-3 mb-auto"
		    :style="{ color : checkColor }"
		    />	    
		  <p class="mb-2">
		    <slot name="bullet-1">Does your 'file management system' hide files in folders?</slot>
		  </p>
		</div>	    
		<div class="d-flex">
		  <font-awesome-icon
		    :icon="faCheck"
		    class="mr-3 mb-auto"
		    :style="{ color : checkColor }"
		    />	    
		  <p class="mb-2">
		    <slot name="bullet-2">Do you have to tag files?</slot>
		  </p>
		</div>
		<div class="d-flex">
		  <font-awesome-icon
		    :icon="faCheck"
		    class="mr-3 mb-auto"
		    :style="{ color : checkColor }"
		    />	    
		  <p class="mb-2">
		    <slot name="bullet-3">Is it frustrating to find the file you need?</slot>
		  </p>
		</div>
		<div class="d-flex">
		  <font-awesome-icon
		    :icon="faCheck"
		    class="mr-3 mb-auto"
		    :style="{ color : checkColor }"
		    />	    
		  <p class="mb-2">
		    <slot name="bullet-4">Is your cloud file management system yet another silo?</slot>
		  </p>
		</div>	      
	      </div>
	    </div>
	    <div class="p-5">
	      <h2 class="text-center">
		<slot name="header-bottom"></slot>
	      </h2>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "Layout03",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    props: {
	checkColor: String
    }
}
</script>
